<template>
    <ModalBox class="ExportSessionBox" v-model="show">
        <div class="line">
            SessionID：{{sessionId}}
            <div class="rightplace">
                <el-button type="primary" @click="copyAllText()">复制所有对话文本</el-button>
                <el-button type="primary" @click="copyToClipboard(url)">复制链接并分享</el-button>
            </div>
        </div>
        <iframe v-if="url" ref="iframe" class="iframe" :src="url"></iframe>
    </ModalBox>
</template>
<script>
import ModalBox from './ModalBox.vue';
import copyToClipboard from 'copy-to-clipboard';
export default {
    name: 'ExportSessionBox',
    components: { ModalBox },
    data () {
        return {
            show: false,
            url: null
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        sessionId: {
            type: String,
            default: null
        }
    },
    mounted () {
        this.show = this.visible;
        if (this.sessionId) this.createUrl();
    },
    watch: {
        visible (val) {
            this.show = val;
        },
        show (val) {
            this.$emit('update:visible', val);
        },
        sessionId (val) {
            this.createUrl();
        }
    },
    methods: {
        copyToClipboard (url) {
            copyToClipboard(url);
            this.$message.success('分享链接已复制到剪贴板');
        },

        copyAllText () {
            if (this.$refs.iframe.contentWindow.copyAllText) {
                this.$refs.iframe.contentWindow.copyAllText();
                this.$message.success('所有文本已复制到剪贴板');
            }
        },

        createUrl () {
            let origin = window.location.origin;
            this.url = `${origin}/call-frontend/session.html?sessionId=${this.sessionId}`;
        }
    }
};
</script>
<style lang="scss" scoped>
.ExportSessionBox {
    .line {
        width: 100%;
        margin: 0.2em;
        text-align: left;
    }
    .rightplace {
        float: right;
    }
    .iframe {
        width: 70vw;
        height: 70vh;
    }
}
</style>
